module.exports = __webpack_public_path__ + "static/media/sticker_station_white.f25607c5.png";